/**
 * Copies text for the guest to paste into their Wi-Fi settings.
 *
 * `navigator.clipboard` needs a secure context and a user gesture; both hold
 * here (Firebase Hosting, a tap on the button). Older WebViews still lack it,
 * so the `execCommand` path stays as a fallback. Returns whether it worked so
 * the caller can say "type it in" rather than claim success.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Fall through to the legacy path.
  }
  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}
